/**
 * @fileoverview Agent definition for character-arc-creation-v2.
 *
 * This agent generates a detailed developmental arc for a single character,
 * including arc name, role, summary, initial/final states, and key turning points.
 *
 * @category entities.characters.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-arc-creation-v2',
  kind: 'primitive',
  name: 'Character Arc Creator',
  description: 'Generates a detailed developmental arc for a single character.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'experimental',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'entities.characters.creation',
    usedBy: ['use-long-story-planner.ts'],
    usedInWorkflows: ['story-planner-workflow-v1'],
    relatedAgents: [
      'character-ideation-v2',
      'character-details-multimodal-generator-v3',
    ],
  },
};
